import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getAuthIsAuthenticated, StoreState } from '../store';
import { RoleStorageService } from './role.storage.service';
import { RecipientOrganizationModel } from 'core/models/recipient.model';
import { UserRoleEnum } from 'core/enums';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(
        public store: Store<StoreState>,
        public router: Router,
        public roleStorageService: RoleStorageService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.store.select(getAuthIsAuthenticated).pipe(
            map(a => {
                const roles = this.roleStorageService.getValue();
                const currentRecipient: RecipientOrganizationModel =
                    this.roleStorageService.getCurrentRecipientValue();
                const isSubRec =
                    roles?.includes(UserRoleEnum.AdminSubRecipient) ||
                    roles?.includes(UserRoleEnum.AdminSubRecipientPlus);
                const recipients = this.roleStorageService.getReceptionsValue();

                if (isSubRec && recipients?.length && !currentRecipient) {
                    this.router.navigate(['auth', 'login'], { queryParams: { next: state.url } });
                    return false;
                }

                if (a) {
                    return true;
                } else {
                    this.router.navigate(['auth', 'login'], { queryParams: { next: state.url } });
                    return false;
                }
            }),
        );
    }
}
